// Formatting utilities — importable from @financialharmony/ui
// All functions are pure (no browser APIs) so they work in SSR, React Native, and edge runtimes.

/** Money is written in Swedish accounting format in every UI language (see `@financialharmony/i18n`'s `formatDate` header). */
export const AMOUNT_LOCALE = "sv-SE"

/**
 * Format a numeric amount in Swedish locale.
 * With currency: "1 234,56 kr" / "1 234,56 €"
 * Without:       "1 234,56"
 */
export function formatAmount(value: string | number, currency?: string): string {
  const num = typeof value === "string" ? parseFloat(value) : value
  if (isNaN(num)) return String(value)

  if (currency) {
    return new Intl.NumberFormat(AMOUNT_LOCALE, {
      style: "currency",
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(num)
  }

  return new Intl.NumberFormat(AMOUNT_LOCALE, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(num)
}
